<template>
  <base-modal>
    <list-scroll v-if="mediafiles.length && !loading" ref="scroll" height="250px" class="mb-4 mt-3">
      <player-row v-for="file in mediafiles" :key="file.file_sln" :file="file">
        <icon slot="controls" class="mb-1" type="md-trash" :size="20" @click="remove(file.id)" />
        <list-state
          v-if="file.state === 'finished'"
          slot="controls"
          :value="is_active(file.id)"
          @click="toggle_select(file)"
        />
      </player-row>
    </list-scroll>

    <file-upload
      :formats="formats"
      :max_file_size="max_file_size"
      :rules="rules"
      :is_loading="loading"
      @before_upload="before_upload"
    />

    <template #footer-cancel="{ close }">
      <i-button size="large" @click="cancel(close)" ref="close">
        {{ $t('shared.component.button.cancel') }}
      </i-button>
    </template>

    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      :disabled="loading"
      :loading="loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import PlayerRow from '@shared/components/file-player-row';
  import ListState from '@shared/components/input/input-state-toggle';
  import FileUpload from '@shared/components/upload-form';
  import { PredictiveMediaService } from '@autocaller_v2/services/PredictiveMediaService';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    components: {
      BaseModal,
      PlayerRow,
      ListState,
      FileUpload
    },
    props: {
      instance_id: {
        type: Number,
        default: 0
      },
      welcome_message_file_id: {
        type: Number,
        default: 0
      },
      files: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      interval_media: null,
      loading: false,
      upload_file: {},
      max_file_size: 11 * 1000 * 1000,
      formats: ['mp3', 'mpga', 'wav'],
      rules: ['weight'],
      selected_file: { id: null },
      initial_selected_file: { id: null }
    }),

    created() {
      const selectedFile = this.mediafiles.find((i) => i.id === this.welcome_message_file_id);

      if (selectedFile?.id) {
        this.selected_file = selectedFile;
        this.initial_selected_file = selectedFile;
      }

      this.interval_media = setInterval(() => {
        PredictiveMediaService.getList(this.instance_id);
      }, 5000);
    },
    computed: {
      ...mapGetters('autocaller_v2/campaigns/table', ['mediafiles'])
    },
    methods: {
      ...mapActions('autocaller_v2/campaigns/table', ['setMediafiles']),

      before_upload: function (data) {
        this.upload_file = data;

        const file = this.upload_file;
        this.loading = true;

        const formData = new FormData();
        formData.append('file', file);

        return PredictiveMediaService.upload(this.instance_id, formData)
          .then(() => {
            this.$noty.success(this.$t('autocaller_v2.campaign.welcome_message.success'));

            PredictiveMediaService.getList(this.instance_id).then((data) => {
              this.setMediafiles(data);

              this.loading = false;
            });

            setTimeout(() => {
              const scrollElement = document.querySelector('.custom-scroll .__panel');
              scrollElement.scrollTop = scrollElement.scrollHeight;
            }, 1500);
          })
          .catch((e) => {
            this.loading = false;
            this.$noty.server_error(e);
            this.$emit('fail', e);
          });
      },
      cancel(action) {
        this.$emit('success', this.initial_selected_file);
        action();
      },
      save() {
        this.$emit('success', this.selected_file);
      },
      is_active: function (id) {
        return this.selected_file.id === id;
      },

      toggle_select(file) {
        if (this.selected_file.id === file.id) {
          this.selected_file = { id: null };
        } else {
          this.selected_file = file;
        }
        this.$emit('input', this.selected_file);
      },
      remove(id) {
        PredictiveMediaService.removeItem(id).then(() => {
          if (this.selected_file.id === id) {
            this.selected_file = { id: null };
          }

          PredictiveMediaService.getList(this.instance_id).then((data) => {
            this.setMediafiles(data);
            this.loading = false;
            this.initial_selected_file = { id: null };
          });

          this.$emit('remove', id);
        });
      }
    },
    destroyed() {
      clearInterval(this.interval_media);
    }
  };
</script>
